
import { arrayOf, nullable, oneOf, oneOfType, shape, string } from 'vue-types';
import { AuthorType } from './parts/Author.vue';
import { IconName } from '@/components/atoms/Icon.vue';
import { customLinkFieldShape, imageShape } from '~/constants/PropTypes';
import { SIZE_MEDIUM, SIZE_SMALL } from '~/constants/General';

export const CardVariant = oneOf(['small', 'featured']);

export const CardProps = shape({
  variant: CardVariant.def('featured'),
  title: oneOfType([string(), nullable()]),
  label: oneOfType([string(), nullable()]),
  buttonLabel: oneOfType([string(), nullable()]),
  body: oneOfType([string(), nullable()]),
  visual: arrayOf(shape(imageShape).loose),
  author: AuthorType,
  link: arrayOf(shape(customLinkFieldShape).loose).def([]),
}).loose;

export default {
  props: {
    card: CardProps,
    buttonIcon: IconName.def('chevron-right'),
  },
  data() {
    return {
      SIZE_MEDIUM,
      SIZE_SMALL,
    };
  },
  computed: {
    cButtonLabel() {
      const { label, locationEntry } = this.$first(this.card.link) || {};
      return (
        this.card.buttonLabel ||
        label ||
        this.$first(locationEntry)?.title ||
        this.$t('readStory')
      );
    },
    contentClass() {
      if (this.card.label) {
        return 'justify-between';
      }
      return 'justify-end';
    },
  },
};
